import { OptionType } from 'bc-front-sagacomponents/lib/src/components/Inputs/Select';
import react from 'react';

export interface ContactFormData {
  nom: string; // 40
  email: string;
  telephone: string;
  immatriculation: string; // 9 caracteres
  motifDemande: string;
  message: string;
}
export const buildMotifList = [
  {
    id: 'PRESTATIONS',
    value: 'Prestations',
  },
  { id: 'RENOUVELLEMENT', value: 'Renouvellement' },
  { id: 'IMPAYE', value: 'Impayé' },
  { id: 'SINISTRE', value: 'Sinistre' },
  {
    id: 'RESILIATION_OU_VENTE',
    value: 'Résiliation / vente',
  },
  {
    id: 'PROBLEME_DE_CONNEXION',
    value: 'Problème de connexion',
  },
  {
    id: 'AUTRE',
    value: 'Autre',
  },
];
